
export function MIOLog(format) {
    console.log(format);
}